module.exports = __webpack_public_path__ + "assets/img/stickers.306232618d89089819aefb216d52adc0.png";